import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';

const rolesColumns: BuiTblColumn[] = [
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    headerTestId: 'roles-name-header',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/roles/edit/${item.id}`, class: 'title-link', 'data-testid': 'list-row-title', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.description ?? ''),
      ]),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default rolesColumns;
